import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ROUTE } from "../constants/routes";
import { useAuth } from "./useAuth";

const ProtectedRoute: React.FC = () => {
  const auth = useAuth();
  const loc = useLocation();

  if (auth.isLoading) {
    return (
      <div role="status" aria-live="polite" style={{ textAlign: "center" }}>
        <span style={{ position: "absolute", left: -9999 }}>
          Verificando sua sessão...
        </span>
        Carregando…
      </div>
    );
  }

  const returnTo = encodeURIComponent(loc.pathname + loc.search);

  if (auth.sessionCheckFailed) {
    return (
      <Stack
        role="alert"
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: "60vh", px: 3, textAlign: "center" }}
      >
        <Typography variant="h6">
          Não foi possível verificar sua sessão
        </Typography>
        <Typography variant="body2" color="text.secondary">
          O servidor demorou para responder. Sua sessão continua salva.
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button variant="contained" onClick={() => void auth.refetchSession()}>
            Tentar novamente
          </Button>
          <Button href={`${ROUTE.SIGNIN}?returnTo=${returnTo}`}>
            Entrar novamente
          </Button>
        </Stack>
      </Stack>
    );
  }

  if (!auth.isAuthenticated) {
    return <Navigate to={`${ROUTE.SIGNIN}?returnTo=${returnTo}`} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
